/*
*模块接口列表
*/
import axios from './http';
//const BASE_URL ='https://beta-api.m.jd.com/api'
const BASE_URL ='https://api.m.jd.com/api'
let api = {
    //公告列表
    ggList(para) {
        return axios.post(BASE_URL+'?appid=tender-web&functionId=tender_queryTenderNoticeList&body={"keyword":"' + para.keyword
                + '","type":' + para.type + ',"types":"'+para.types+'","page":' + para.page + ',"size":' + para.size + '}')
    },
    //公告详情,
    ggView(para) {
        return axios.post(BASE_URL+'?appid=tender-web&functionId=tender_queryTenderNoticeById&body={"id":'+ para.id+ '}')
    },
    //是否有变更公告,
    sfbgView(para) {
        return axios.post(BASE_URL +'?appid=tender-web&functionId=tender_isExistChangeNotice&body={"tenderId":' + para.tenderId + ',"type":' + para.type+'}')
    },
    //获取token,
    getToken(para) {
        return axios.post(BASE_URL +'?appid=tender-web&functionId=tender_preJumpToOut&body={"tenderId":' + para.tenderId + '}')
    },
    //查询中标信息
    getBidder(para) { 
        return axios.post(BASE_URL +'?appid=tender-web&functionId=tender_getBidderIntentionByTenderId&body={"tenderId":' + para.tenderId + '}')
    },
    //是否实名
    isAuthenticate() { 
        return axios.post(BASE_URL +'?appid=tender-web&functionId=tender_isAuthenticate')
    },
    //去支付
    goPay(para){
        return axios.post(BASE_URL +'?appid=tender-web&functionId=tender_submitServiceOrder&body={"tenderId":' + para.tenderId +',"orderPrice":'+para.serviceCharge+'}')
    }
}
export default api;